<!--
 * @Author: your name
 * @Date: 2020-11-12 17:40:42
 * @LastEditTime: 2021-07-13 17:44:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/BottomPopupDialog/index.vue
-->
<style scoped lang="sass">

.app_container
  position: relative
  display: flex
  flex-direction: column
  justify-content: space-between

  .title
    position: absolute
    top: 11PX
    padding: 5PX
    width: calc( 100% - 30PX )
    height: 36PX
    line-height: 26PX
    color: #334455
    font-size: 18PX
    font-weight: bold
    text-align: center

.close_icon
  position: absolute
  top: 3PX
  right: 18PX
  z-index: 5
  padding: 5PX
  color: var(--menu-primary-background-colour) !important
  cursor: pointer

::v-deep
  .van-button--primary
    border: none
    border-radius: 5PX !important

.loading_popup
  position: absolute !important
  left: 0

.top_popup_dialog
  margin-top: 22PX

.fixed
  .app_container
    padding: 26PX 0

  ::v-deep
    .close_icon
      position: fixed
      top: auto

    .close_icon
      margin-top: -77PX
      padding-top: 0
      z-index: 2

.van-popup
  border-top-left-radius: 18px
  border-top-right-radius: 18px

</style>

<template lang="pug">
van-popup(
  :class="{'fixed': isFixed}"
  :value="show"
  :close-on-click-overlay="false"
  :round="round"
  :position="position"
)
  .app_container
    .title(v-if="title") {{ title }}
    div(:class="{'top_popup_dialog': title}")
      slot(name="popup-dialog")
    //- icon(v-if="showCloseIcon" size="26").close_icon(@click="closeDialog") close
    py-loading.loading_popup(:showLoading="showPopupLoading" :size="popupLoadingSize")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import dayjs from 'dayjs'

@Component({
  model: {
    prop: 'show',
    event: 'changeShow'
  },
  props: {
    show: {
      type: Boolean
    },

    title: {
      type: String
    },

    showCloseIcon: {
      type: Boolean,
      default: true
    },

    round: {
      type: Boolean,
      default: true
    },

    color: {
      type: String,
      default: '#000'
    },

    popupLoadingSize: {
      type: String,
      default: '50'
    },

    showPopupLoading: {
      type: Boolean,
      default: false
    },

    isFixed: {
      type: Boolean,
      default: false
    },

    position: {
      type: String,
      default: 'bottom'
    }
  }
})

class BottomPopupDialog extends Vue {
  closeDialog() {
    this.$emit('changeShow', false)
    this.$emit('closeDialog')
  }
}

export default BottomPopupDialog
</script>
